module.exports = __webpack_public_path__ + "static/media/soc-net.2d3e9636.png";